$(document).ready(function () {
	$('.mobile-trigger').click(function (e) {
		//$(this).toggleClass('active-re');
		//$('#navbarsId').slideToggle();
		$('#navbarsId').toggleClass('activemenu');
		e.stopPropagation();
	});
	$('.nav-link').click(function () {
		$(this).next('.submenu').slideToggle();
		$(".submenu").not($(this).next(".submenu")).slideUp();
	});

	$('#navbarsId').click(function (e) {
		e.stopPropagation();
	});


	$('.probig').slick({
		lazyLoad: 'ondemand',
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		prevArrow: "<i class='icon-down-open left'></i>",
		nextArrow: "<i class='icon-down-open right'></i>",
		fade: false,
        adaptiveHeight: true,
		centerMode: true,
		asNavFor: '.prosmall'
	});
	$('.prosmall').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		asNavFor: '.probig',
		dots: false,
		centerMode: true,
		focusOnSelect: true,
		arrows: true,
		prevArrow: "<i class='icon-down-open left'></i>",
		nextArrow: "<i class='icon-down-open right'></i>",
		responsive: [{
			breakpoint: 576,
			settings: {
				slidesToShow: 3,
			}
		},]
	}).on('setPosition', function () {
		resizeheight();
	});

	$(".accord-title").click(function () {
		$(this).toggleClass("close-slide");
		$(this).next(".accord-body").slideToggle();
		$(".accord-body").not($(this).next(".accord-body")).slideUp();
		$(".accord-title").not($(this)).removeClass("close-slide")
	});

	$('.gocheck').on('click', function (e) {
		var target = $(this).attr('href');
		if(target.indexOf('#') == 0) {
			e.preventDefault();
			var $target = $(target);
			$('html, body').stop().animate({
				'scrollTop': $target.offset().top
			}, 900, 'swing', function () {
				// window.location.hash = target;
			});
			$(this).addClass('active');
			$(this).siblings().removeClass('active');
		}
	});

	document.addEventListener('lazybeforeunveil', function (e) {
		var bg = e.target.getAttribute('data-bg');
		if (bg) {
			e.target.style.backgroundImage = 'url(' + bg + ')';
		}
	});

	$(".fancybox").fancybox();

	String.prototype.getDecimals || (String.prototype.getDecimals = function () {
		var a = this,
			b = ("" + a).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
		return b ? Math.max(0, (b[1] ? b[1].length : 0) - (b[2] ? +b[2] : 0)) : 0
	});
	$(".plus, .minus").click(function () {
		var a = jQuery(this).closest(".quantity").find(".qty"),
			b = parseFloat(a.val()),
			c = parseFloat(a.attr("max")),
			d = parseFloat(a.attr("min")),
			e = a.attr("step");
		b && "" !== b && "NaN" !== b || (b = 0), "" !== c && "NaN" !== c || (c = ""), "" !== d && "NaN" !== d || (d = 0), "any" !== e && "" !== e && void 0 !== e && "NaN" !== parseFloat(e) || (e = 1), jQuery(this).is(".plus") ? c && b >= c ? a.val(c) : a.val((b + parseFloat(e)).toFixed(e.getDecimals())) : d && b <= d ? a.val(d) : b > 0 && a.val((b - parseFloat(e)).toFixed(e.getDecimals())), a.trigger("change")
		a.attr('value', a.val());
	});


	$('.reliefwrap h3').matchHeight({
		byRow: true
	});

	var resizeheight = function () {
		var m = $('.prosmall .slick-slide').width();
		$('.prosmall .slick-slide').css('height', m);
	};
  	if($("body.template-collection .mostpopular .prowrap").length > 0)
  	{
  		$('body.template-collection .mostpopular .prowrap .proimg img').matchHeight({
			byRow: true
		});
  	}




});
$(window).on("load", function(){
	if($("body.template-collection .mostpopular .prowrap").length > 0)
  	{
  		$('body.template-collection .mostpopular .prowrap .proimg img').removeAttr("style");
  		setTimeout(function(){
	  		$('body.template-collection .mostpopular .prowrap .proimg img').matchHeight({
				byRow: true
			});
		}, 1000);
  	}
});